import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import * as SecureLS from "secure-ls";
import { HttpClient } from "@angular/common/http";
import {
  MatSnackBar,
  MatDatepicker,
  MatDatepickerInputEvent,
  MatDialog,
} from "@angular/material";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { FormControl, Validators } from "@angular/forms";
import { MediaObserver, MediaChange } from "@angular/flex-layout";
import {
  BlobService,
  UploadConfig,
  UploadParams,
} from "angular-azure-blob-service";
import { Subscription } from "rxjs";
import * as momento from "moment";
import * as colombia from "colombia-holidays";
import { GlobalVariable } from "src/app/config/global";
import { User } from "src/app/model/user";
import { Employee } from "src/app/model/employee";
import { EmployeeService } from "src/app/service/employee.service";
import { BusinessUnit } from "src/app/model/businessUnit";
import { BusinessunitService } from "src/app/service/businessunit.service";
import { VacationService } from "src/app/service/vacation.service";
import { RequestService } from "src/app/service/request.service";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { RequestType } from "src/app/model/requestType";
declare var moment: any;

const Config: UploadParams = {
  sas: "?sv=2023-01-03&spr=https%2Chttp&st=2025-03-03T17%3A11%3A35Z&se=2030-12-31T17%3A11%3A00Z&sr=c&sp=racwlf&sig=N2U3%2FiZ2lSJke57oaDZ5Bhc45%2FpI8Vn7JxX62aJKgnU%3D",
  storageAccount: "dwsda",
  containerName: "helpempermissionfiles",
};

@Component({
  selector: "app-permissionrequest",
  templateUrl: "./permissionrequest.component.html",
  styleUrls: ["./permissionrequest.component.scss"],
})
export class PermissionrequestComponent implements OnInit {
  AppName = "";
  currentScreenWidth: string = "";
  flexMediaWatcher: Subscription;
  sidenavWidth = 4.2;
  ls: SecureLS;
  // user information
  user: User;
  isLoading = false;
  errorMessage = "";
  // employee information
  employee: Employee;
  employees: Employee[];
  // Business Unit information
  selectBusinessUnit: FormControl;
  businessUnits: BusinessUnit[] = [];
  selectedBusinessUnit = <BusinessUnit>{
    id: "",
  };
  emergencyName;
  emergencyPhone;
  description;
  // date picker
  date: FormControl;
  time: FormControl;
  dateEnd: FormControl;
  timeEnd: FormControl;
  dateReturning: FormControl;
  endDateError = false;
  returningDateError = false;
  dateYear: FormControl;
  myFilter = (d: Date): boolean => {
    const day = d.getDay();
    return true;
  };
  // vacation information
  availableDays: number = 0;
  requestedDays: number = 0;
  remainingDays: number = 0;
  //requests
  requestTypes: RequestType[] = [];
  selectedRequestType = <RequestType>{
    id: "",
  };
  selectedReportRequestType = <RequestType>{
    id: "",
  };
  requests = [];
  requestsFilter = [];
  inProcessRequests = [];
  approvedRequests = [];
  rejectedRequests = [];
  humanResources;
  // Upload information
  successUploadedFile;
  totalFiles = 0;
  errorFileNameMessage = "";
  isUploading = false;
  config: UploadConfig;
  percent: number;
  selectedFile: any;
  @ViewChild("fileInput", { static: false })
  fileInput: ElementRef<HTMLInputElement>;
  constructor(
    private router: Router,
    private employeeService: EmployeeService,
    private businessunitService: BusinessunitService,
    private vacationService: VacationService,
    private requestService: RequestService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private http: HttpClient,
    private mediaObserver: MediaObserver,
    private blob: BlobService
  ) {
    this.flexMediaWatcher = mediaObserver.media$.subscribe(
      (change: MediaChange) => {
        if (change.mqAlias !== this.currentScreenWidth) {
          this.currentScreenWidth = change.mqAlias;
        }
      }
    );
  }

  ngOnInit() {
    this.AppName = GlobalVariable.APP_NAME;
    this.ls = new SecureLS({ encodingType: "aes" });
    if (!this.validateSession()) {
      this.router.navigate(["/login"]);
      return;
    }
    this.initForms();
    this.getEmployeeData();
  }

  ngOnDestroy(): void {
    this.flexMediaWatcher.unsubscribe();
  }

  increase() {
    this.sidenavWidth = 16;
  }
  decrease() {
    this.sidenavWidth = 4.2;
  }

  resetForm() {
    this.emergencyName = "";
    this.emergencyPhone = "";
    this.description = "";
  }

  /** validate a valid session exists*/
  validateSession(): boolean {
    if (localStorage.getItem("uid") === null) {
      return false;
    } else {
      return true;
    }
  }

  /** function to init the forms */
  initForms() {
    this.selectBusinessUnit = new FormControl("", [Validators.required]);
    this.date = new FormControl({ value: new Date(), disabled: false });
    this.time = new FormControl();
    this.dateEnd = new FormControl({ value: new Date(), disabled: false });
    this.timeEnd = new FormControl();
    this.dateYear = new FormControl({ value: new Date(), disabled: false });
    this.dateReturning = new FormControl({ value: new Date(), disabled: true });
  }

  getErrorMessage(component: string) {
    let errorMessage = "";
    switch (component) {
      case "endDate":
        errorMessage = "La fecha final debe ser mayor a la inicial";
        break;
      case "returningDate":
        errorMessage = "La fecha de retorno debe ser mayor a la final";
        break;
    }
    return errorMessage;
  }

  /** function to get the current logged in user, call the function to get projects or register the API Token */
  getEmployeeData() {
    this.isLoading = true;
    this.employee = <Employee>{
      id: "",
    };
    const userid = this.ls.get("uid");
    this.employeeService.getEmployee(userid).subscribe(
      (p) => {
        this.employees = p.results !== undefined ? p.results : [];
        this.employee = p.results !== undefined ? p.results[0] : null;
      },
      (e) => this.launchMessage(e),
      () => {
        if (
          this.employee.boss_id.trim() == "" &&
          this.employee.boss_name.trim() == "" &&
          this.employee.boss_email.trim() == ""
        ) {
          this.businessunitService
            .getBusinessUnit(this.employee.bu_code)
            .subscribe(
              (p) =>
                (this.humanResources =
                  p.results !== undefined ? p.results[0] : ""),
              (e) => this.launchMessage(e),
              () => {}
            );
        }
        this.isLoading = false;
        if (this.employee) {
          this.getBusinessUnitByEmployee();
        }
      }
    );
  }

  getBusinessUnitByEmployee() {
    this.isLoading = true;
    this.employees.map((employee) => {
      let bu: BusinessUnit;
      this.businessunitService.getBusinessUnit(employee.bu_code).subscribe(
        (p) => (bu = p.results !== undefined ? p.results[0] : null),
        (e) => this.launchMessage(e),
        () => {
          this.isLoading = false;
          if (bu) {
            this.businessUnits.push(bu);
          }
          this.selectedBusinessUnit = this.businessUnits.find(
            (bu) => bu.id == this.employee.bu_code
          );
          if (this.selectedBusinessUnit) {
            //call the function to get vacations information
            this.getRequestTypes();
          }
        }
      );
    });
  }

  /** Event handler when business unit select component changes */
  buSelectionChange(event: { value: BusinessUnit }) {
    this.selectedBusinessUnit = event.value;
    this.employee = this.employees.find((e) => e.bu_code === event.value.id);
    //call the function to get vacations information
    this.getRequest();
  }

  /** Event handler when date picker component value changes */
  chosenStartDateHandler(event: MatDatepickerInputEvent<Date>) {
    this.dateEnd.setValue(event.value);
    this.dateReturning.setValue(event.value);
    this.endDateError = false;
    this.returningDateError = false;
    // if (this.employee) {
    //   this.calculateRequestedDays();
    // }
  }

  /** Event handler when date picker component value changes */
  chosenEndDateHandler(event: MatDatepickerInputEvent<Date>) {
    this.requestedDays = 0;
    const startDate = moment(this.date.value);
    const endDate = moment(event.value);
    // const diff = endDate.diff(startDate, "days") + 1;
    // if (diff <= 0) {
    //   this.endDateError = true;
    // } else {
    //   this.endDateError = false;
    //   const oneDayAfter = moment(event.value)
    //     .add(this.calculateNextBusinessDay(), "d")
    //     .format();
    //   this.dateReturning.setValue(oneDayAfter);
    //   if (this.employee) {
    //     this.calculateRequestedDays();
    //   }
    // }
  }

  /** Event handler when date picker component value changes */
  chosenReturningDateHandler(event: MatDatepickerInputEvent<Date>) {
    const endDate = moment(this.dateEnd.value);
    const returningDate = moment(event.value);
    // const diff = returningDate.diff(endDate, "days") + 1;
    // if (diff < 0) {
    //   this.returningDateError = true;
    // } else {
    //   this.returningDateError = false;
    //   if (this.employee) {
    //     this.calculateRequestedDays();
    //   }
    // }
  }

  calculateNextBusinessDay() {
    var stopIf = 1;
    var daysToAdd = 0;
    var diffBusinessDays = 0;
    const endDate = moment(this.dateEnd.value).format();
    const dateBusinessDays = this.getBusinessDays(endDate, endDate);
    if (dateBusinessDays == 1) {
      stopIf = 2;
    } else {
      stopIf = 1;
    }
    while (diffBusinessDays < stopIf) {
      daysToAdd++;
      var oneDayAfter = moment(endDate).add(daysToAdd, "d").format();
      diffBusinessDays = this.getBusinessDays(endDate, oneDayAfter);
    }
    return daysToAdd;
  }

  getBusinessDays(startDate, endDate) {
    var startDateMoment = moment(startDate);
    var endDateMoment = moment(endDate);
    var holidaysFirstYear = colombia
      .getColombiaHolidaysByYear(startDateMoment.year())
      .map(({ holiday }) => holiday);
    var holidaysSecondYear = colombia
      .getColombiaHolidaysByYear(endDateMoment.year())
      .map(({ holiday }) => holiday);
    var twoYearHolidays = [...holidaysFirstYear, ...holidaysSecondYear];

    var days = moment().isoWeekdayCalc({
      rangeStart: startDateMoment,
      rangeEnd: endDateMoment,
      weekdays: [1, 2, 3, 4, 5],
      exclusions: twoYearHolidays,
    });
    return days;
  }

  showFileDialog(): void {
    this.fileInput.nativeElement.click();
  }

  readFiles(fileInput: any) {
    this.successUploadedFile = 0;
    this.totalFiles = 0;
    this.errorFileNameMessage = "";
    const fileList = fileInput.target.files;
    this.totalFiles = fileList.length;
    const _fileList: any[] = Object.values(fileList);
    this.selectedFile = _fileList[0];
    // private blobUploadsState: BlobUploadsviewstateService,
    this.fileInput.nativeElement.value = "";
  }

  uploadFileToBlob(currentFile, requestid) {
    if (currentFile !== null) {
      this.isLoading = true;
      const baseUrl = this.blob.generateBlobUrl(
        Config,
        this.employee.bu_code +
          "/" +
          this.employee.id +
          "/" +
          requestid +
          "_DOCUMENTOSPORTE" +
          "." +
          currentFile.name.split(".")[1]
      );
      this.config = {
        baseUrl: baseUrl,
        sasToken: Config.sas,
        blockSize: 1024 * 64, // OPTIONAL, default value is 1024 * 32
        file: currentFile,
        complete: () => {
          this.isLoading = false;
          this.successUploadedFile++;
          this.percent = 0;
        },
        error: (err) => {
          this.isLoading = false;
          this.percent = 0;
        },
        progress: (percent) => {
          this.percent = percent;
        },
      };
      this.blob.upload(this.config);
    }
  }

  createRequest() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "350px",
      data: "¿Estás seguro que quieres crear la solicitud?",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // DO SOMETHING
        let requestid = "";
        const submission = this.buildJSONToPostRequest();
        this.requestService.postRequest(submission).subscribe(
          (p) => {
            if (p.message) {
              this.launchMessage("Se ha creado tu solicitud exitosamente");
              requestid = p.message.split(":")[1];
            }
          },
          (e) => this.launchMessage(e),
          () => {
            if (requestid !== "" && this.selectedFile != null) {
              this.uploadFileToBlob(this.selectedFile, requestid);
            }
            this.isLoading = false;
            this.date.setValue(new Date());
            this.time.setValue(new FormControl());
            this.dateEnd.setValue(new Date());
            this.timeEnd.setValue(new FormControl());
            this.dateReturning.setValue(new Date());
            this.requestedDays = 0;
            this.remainingDays = 0;
            this.selectedFile = null;
            this.resetForm();
            this.getRequest();
          }
        );
      }
    });
  }

  /** this method builds the json using the data enter in the form and selected assets */
  buildJSONToPostRequest(): any {
    const now = new Date();
    const month = now.getMonth() + 1;
    const x = {
      id: "2",
      date:
        now.getFullYear() +
        "-" +
        month +
        "-" +
        now.getDate() +
        " " +
        now.getHours() +
        ":" +
        now.getMinutes() +
        ":" +
        now.getSeconds(),
      employee_id: this.employee.id,
      boss_id: this.employee.boss_id,
      start_date: this.date.value,
      start_time: this.time.value,
      end_date: this.dateEnd.value,
      end_time: this.timeEnd.value,
      entrance_date: this.dateEnd.value,
      days: 0,
      type: this.selectedRequestType.id,
      type_description: this.selectedRequestType.description,
      status: "2",
      observation: "",
      bu_code: this.employee.bu_code,
      contact_name: this.emergencyName,
      contact_phone: this.emergencyPhone,
      description: this.description,
      attached: this.selectedFile ? "1" : "0",
      type_attached: this.selectedFile
        ? this.selectedFile.name.split(".")[1]
        : "",
    };
    return x;
  }

  getRequestTypes() {
    this.isLoading = true;
    let rt: RequestType;
    this.requestService.getRequestType().subscribe(
      (p) => {
        rt = p.results !== undefined ? p.results[0] : null;
        this.requestTypes = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        this.selectedRequestType = rt;
        this.selectedReportRequestType = rt;
        if (this.selectedRequestType && this.selectedBusinessUnit) {
          this.getRequest();
        }
      }
    );
  }

  getRequest() {
    this.requestService
      .getPermissionRequestsByEmployeeBUYearType(
        this.employee.id,
        this.employee.bu_code,
        this.dateYear.value.getFullYear() + "-01-01",
        this.dateYear.value.getFullYear() + "-12-31",
        this.selectedReportRequestType.id
      )
      .subscribe(
        (p) => {
          this.requests = p.results !== undefined ? p.results : [];
        },
        (e) => this.launchMessage(e),
        () => {
          this.isLoading = false;

          // Vacations filter
          this.requestsFilter = this.requests.filter((r) => r.type !== "1");

          if (this.requestsFilter.length > 0) {
            momento.locale("es");
            this.requestsFilter.forEach((request) => {
              request.date = momento(request.date, "YYYY-MM-DD").format(
                "DD MMMM YYYY"
              );
              request.start_date = momento(
                request.start_date,
                "YYYY-MM-DD"
              ).format("DD MMMM YYYY");
              request.end_date = momento(request.end_date, "YYYY-MM-DD").format(
                "DD MMMM YYYY"
              );
              request.entrance_date = momento(
                request.entrance_date,
                "YYYY-MM-DD"
              ).format("DD MMMM YYYY");
            });
            this.inProcessRequests = this.requestsFilter.filter(
              (r) => r.status === "1" || r.status === "2"
            );
            this.approvedRequests = this.requestsFilter.filter(
              (r) => r.status === "5"
            );
            this.rejectedRequests = this.requestsFilter.filter(
              (r) => r.status === "3" || r.status === "4"
            );
          } else {
            this.inProcessRequests = [];
            this.approvedRequests = [];
            this.rejectedRequests = [];
          }
        }
      );
  }

  /** Event handler when date picker component value changes */
  chosenYearHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    this.dateYear.setValue(normalizedMonth);
    datepicker.close();
    if (this.employee) {
      //get information by year
      this.getRequest();
    }
  }

  /** Event handler when business unit select component changes */
  rtReportSelectionChange(event: { value: RequestType }) {
    this.selectedRequestType = event.value;
    this.getRequest();
  }

  launchMessage(message: string) {
    this.errorMessage = "";
    this.isLoading = false;
    const action = "OK";
    this.snackBar.open(message, action, {
      duration: 4000,
    });
  }
}
